<app-header
  icon="fas fa-layer-group"
  text="Navigation"
  sub="Hier können Sie Themenbereiche auswählen, die im Atlas als Navigation dienen sollen."></app-header>
<p-divider />

<p-pickList
  [showSourceControls]="false"
  [dragdrop]="true"
  [filterBy]="availableItems.length > 10 ? 'title' : undefined"
  [sourceStyle]="{ height: '30rem' }"
  [targetStyle]="{ height: '30rem' }"
  targetHeader="Auswahl für die Navigation"
  sourceHeader="Themenbereiche"
  (onMoveToSource)="saveToAtlasConfig()"
  (onMoveToTarget)="saveToAtlasConfig()"
  (onTargetReorder)="saveToAtlasConfig()"
  (onMoveAllToSource)="saveToAtlasConfig()"
  (onMoveAllToTarget)="saveToAtlasConfig()"
  [target]="selection"
  [source]="availableItems">
  <ng-template let-category pTemplate="item">
    <div class="flex-1 flex flex-column gap-2">
      <div class="flex align-items-center gap-2">
        <i class="fas fa-layer-group"></i>
        <span>
          {{ category.title }}
        </span>
      </div>
    </div>
  </ng-template>
</p-pickList>
